import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBold = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	viewBox: "-4 -4 32 32",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m8.667 5h4.333c2.089 0 3.667 1.565 3.667 3.5s-1.578 3.5-3.667 3.5h-4.333m0 0h5.333c2.127 0 3.667 1.584 3.667 3.5s-1.54 3.5-3.667 3.5h-5.333m-2.667-14h2.667v14h-2.667",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 3
	})
});
export default SvgBold;
